import "../../../../assets/css/screens/customer/dashboard/mybookings/MyBookings.css";
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import { useBookingDetail } from '../../../../context/bookingdetailcontext/BookingDetailContext';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Calendar, Clock, MapPin, Star, CheckCircle,
  AlertCircle, CheckCheck, XCircle, DollarSign, ShieldAlert,
  Upload, X, Play, Image as ImgIcon, Send, MessageSquare, User,
  Headphones
} from 'lucide-react';
import AppContext from "../../../../context/AppContext";

/* ══════════ STATES ══════════ */
const STATES = {
  worker_dispute:        { label:'Disputed',              color:'#f97316', bg:'rgba(249,115,22,0.10)'  },
  customer_dispute:      { label:'My Dispute',            color:'#f97316', bg:'rgba(249,115,22,0.10)'  },
  draft:                 { label:'Draft',                 color:'#94a3b8', bg:'rgba(148,163,184,0.10)' },
  open:                  { label:'Pending',               color:'#0491e1', bg:'rgba(4,145,225,0.10)'   },
  assigned:              { label:'Assigned',              color:'#8b5cf6', bg:'rgba(139,92,246,0.10)'  },
  in_progress:           { label:'In Progress',           color:'#f59e0b', bg:'rgba(245,158,11,0.10)'  },
  awaiting_confirmation: { label:'Awaiting Confirmation', color:'#06b6d4', bg:'rgba(6,182,212,0.10)'   },
  completed:             { label:'Completed',             color:'#10b981', bg:'rgba(16,185,129,0.10)'  },
  dispute_frozen:        { label:'Dispute Frozen',        color:'#ef4444', bg:'rgba(239,68,68,0.10)'   },
  cancelled:             { label:'Cancelled',             color:'#ef4444', bg:'rgba(239,68,68,0.10)'   },
  refunded:              { label:'Refunded',              color:'#10b981', bg:'rgba(16,185,129,0.10)'  },
  admin_review:          { label:'Admin Review',          color:'#f59e0b', bg:'rgba(245,158,11,0.10)'  },
};

const TABS = ['All','open','assigned','in_progress','awaiting_confirmation','completed','cancelled','customer_dispute'];


/* ══════════ IN-MEMORY STORE ══════════ */
let _bookings = [
  // { id:'cb-1',  service:'AC Repair & Maintenance', worker:'Ali Hassan',    location:'Pietersburg', date:'Apr 01, 2026', time:'10:00 AM', price:3500,
  //   state:'open', workerMedia:[], customerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1631545804623-83852ba9c961?w=400&q=80'}], note:'AC not cooling. Please fix urgently.', review:null },
  // { id:'cb-2',  service:'Roof Leakage Fix',         worker:'Hassan Tariq', location:'Lahore',      date:'Apr 01, 2026', time:'11:00 AM', price:2800,
  //   state:'open', workerMedia:[], customerMedia:[], note:'Water dripping in bedroom during rain.', review:null },
  // { id:'cb-3',  service:'Electrical Wiring',        worker:'Sara Malik',   location:'Karachi',     date:'Apr 02, 2026', time:'2:00 PM',  price:5000,
  //   state:'assigned', workerMedia:[], customerMedia:[{type:'video',url:'https://www.w3schools.com/html/mov_bbb.mp4',thumb:'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400&q=80'}], note:'Full house rewiring.', review:null },
  // { id:'cb-4',  service:'Plumbing Installation',    worker:'Bilal Ahmed',  location:'Faisalabad',  date:'Apr 02, 2026', time:'9:00 AM',  price:3200,
  //   state:'assigned', workerMedia:[], customerMedia:[], note:'New bathroom fittings.', review:null },
  // { id:'cb-5',  service:'Wall Painting 2 Rooms',    worker:'David Wilson', location:'Islamabad',   date:'Apr 03, 2026', time:'10:00 AM', price:12000,
  //   state:'in_progress', workerMedia:[], customerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400&q=80'}], note:'', review:null },
  // { id:'cb-6',  service:'Deep House Cleaning',      worker:'Sarah Miller', location:'Pietersburg', date:'Apr 03, 2026', time:'2:00 PM',  price:4000,
  //   state:'in_progress', workerMedia:[], customerMedia:[], note:'3 bedroom house cleaning.', review:null },
  // { id:'cb-7',  service:'Kitchen Renovation',       worker:'Usman Ali',    location:'Islamabad',   date:'Apr 04, 2026', time:'9:00 AM',  price:18000,
  //   state:'awaiting_confirmation',
  //   workerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80'},{type:'image',url:'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=400&q=80'}],
  //   customerMedia:[], note:'', review:null },
  // { id:'cb-8',  service:'Bathroom Tiles Work',      worker:'Imran Butt',   location:'Multan',      date:'Mar 28, 2026', time:'11:00 AM', price:7500,
  //   state:'awaiting_confirmation', workerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400&q=80'}], customerMedia:[], note:'', review:null },
  // { id:'cb-9',  service:'Roof Waterproofing',       worker:'Ahmed Khan',   location:'Karachi',     date:'Mar 25, 2026', time:'10:00 AM', price:9000,
  //   state:'completed', workerMedia:[{type:'image',url:'https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?w=400&q=80'}], customerMedia:[], note:'', review:{ rating:5, text:'Excellent work!' } },
  // { id:'cb-10', service:'Furniture Repair',         worker:'Amna Tariq',   location:'Lahore',      date:'Mar 20, 2026', time:'2:00 PM',  price:4500,
  //   state:'completed', workerMedia:[], customerMedia:[], note:'', review:{ rating:4, text:'Good service.' } },
  // { id:'cb-11', service:'Carpet Cleaning',          worker:'Zara Sheikh',  location:'Islamabad',   date:'Mar 15, 2026', time:'3:00 PM',  price:2000,
  //   state:'cancelled', workerMedia:[], customerMedia:[], note:'', review:null },
  // { id:'cb-12', service:'Woodwork Cabinets',        worker:'Fahad Malik',  location:'Karachi',     date:'Mar 10, 2026', time:'9:00 AM',  price:6000,
  //   state:'dispute_frozen', workerMedia:[], customerMedia:[], note:'', review:null },
];

const updateBooking = (id, patch) => { _bookings = _bookings.map(b => b.id===id ? {...b,...patch} : b); };
// const updateBid = (id, patch) => { _bids = _bids.map(b => b.id===id ? {...b,...patch} : b); };
/* ══════════ LIGHTBOX ══════════ */
const Lightbox = ({ item, onClose }) => {
  if (!item) return null;
  return (
    <div className="mb2-lb" onClick={onClose}>
      <button className="mb2-lb__close" onClick={onClose}><X size={20}/></button>
      <div className="mb2-lb__content" onClick={e => e.stopPropagation()}>
        {item.type==='video'
          ? <video src={item.url} controls autoPlay className="mb2-lb__media"/>
          : <img src={item.url} alt="" className="mb2-lb__media"/>}
      </div>
    </div>
  );
};

/* ══════════ STARS ══════════ */
const Stars = ({ rating }) => (
  <div className="mb2-stars">
    {[1,2,3,4,5].map(s => (
      <Star key={s} size={13} fill={s<=rating?'#f59e0b':'#e5e7eb'} color={s<=rating?'#f59e0b':'#e5e7eb'}/>
    ))}
  </div>
);

/* ══════════ STAR PICKER ══════════ */
const StarPicker = ({ value, onChange }) => (
  <div className="mb2-star-picker">
    {[1,2,3,4,5].map(s => (
      <button key={s} className="mb2-star-picker__btn" onClick={() => onChange(s)} type="button">
        <Star size={22} fill={s<=value?'#f59e0b':'#e5e7eb'} color={s<=value?'#f59e0b':'#e5e7eb'}/>
      </button>
    ))}
  </div>
);

/* ══════════ MAIN ══════════ */
const MyBookings = () => {
  const navigate = useNavigate();
  const {baseUrl} = useContext(AppContext);
  const [bookings,  setBookings] = useState([]);
  const [activeTab, setActive]   = useState('All');
  const [lightbox,  setLightbox] = useState(null);
  const [reviews,   setReviews]  = useState({});

  const refresh = () => setBookings([..._bookings]);

  const handleConfirm         = id => { updateBooking(id, { state:'completed' });       refresh(); };
  // const handleDispute         = id => { updateBooking(id, { state:'customer_dispute' }); refresh(); }; // FIX 1: dispute_frozen → customer_dispute
  // const handleCustomerDispute = id => { updateBooking(id, { state:'customer_dispute' }); refresh(); };

  const handleReview = (id) => {
    const r      = reviews[id] || {};
    const text   = (r.text  || '').trim();
    const rating = r.rating || 5;
    if (!text) return;
    updateBooking(id, { review: { rating, text } });
    setReviews(prev => ({ ...prev, [id]: {} }));
    refresh();
  };
  // ── Raise dispute: generate ticketId, update state, navigate to help-support ──
  const handleDispute = (bid) => {
    const ticketId = 'TKT-' + Date.now().toString().slice(-4);
updateBooking(bid.id, { state:'customer_dispute', ticketId });    refresh();
    navigate('/customer-support', {
      state: {
        fromDispute: true,
        ticketId,
        jobId:    bid.id,
        jobTitle: bid.title,
        worker:   bid.worker,
      }
    });
  };

  // ── Open existing ticket chat ──
  const openTicketChat = (bid) => {
    navigate('/chat', {
      state: {
        openTicket: true,
        ticketId:   bid.ticketId,
        jobId:      bid.id,
        jobTitle:   bid.title,
        worker:     bid.worker,
      }
    });
  };

  const setReviewField = (id, key, val) =>
    setReviews(prev => ({ ...prev, [id]: { ...(prev[id]||{}), [key]: val } }));

  const filtered = bookings.filter(b => activeTab==='All' ? true : b.state===activeTab);
  const cnt      = t => bookings.filter(b => b.state===t).length;

  return (
    <>
      <AppNavbar/>
      <div className="mb2-page">

        <div className="mb2-header">
          <button className="mb2-back" onClick={() => navigate(-1)}><ArrowLeft size={20}/></button>
          <h2 className="mb2-title">My Bookings</h2>
        </div>

        <div className="mb2-tabs">
          {TABS.map(t => (
            <button key={t} className={'mb2-tab'+(activeTab===t?' mb2-tab--active':'')} onClick={() => setActive(t)}>
              {t==='All' ? 'All' : (STATES[t]?.label || t)}
              {t!=='All' && cnt(t)>0 && <span className="mb2-tab__count">{cnt(t)}</span>}
            </button>
          ))}
        </div>

        <div className="mb2-list">
          {filtered.length===0
            ? <div className="mb2-empty"><p>No bookings in this state.</p></div>
            : filtered.map((b, i) => {
              const st = STATES[b.state] || STATES.open;
              const rv = reviews[b.id] || {};

              return (
                <div key={b.id} className="mb2-card" style={{ animationDelay: i*0.06+'s' }}>

                  {/* Top */}
                  <div className="mb2-card__top">
                    <div>
                      <h5 className="mb2-card__service">{b.service}</h5>
                      <span className="mb2-card__worker"><User size={12}/> {b.worker}</span>
                    </div>
                    <span className="mb2-card__status" style={{ color:st.color, background:st.bg }}>{st.label}</span>
                  </div>

                  {/* Meta */}
                  <div className="mb2-card__meta">
                    <span><Calendar size={13}/> {b.date}</span>
                    <span><Clock size={13}/> {b.time}</span>
                    <span><MapPin size={13}/> {b.location}</span>
                  </div>

                  {/* Price */}
                  <div className="mb2-card__price-row">
                    <span className="mb2-card__price-label">Price:</span>
                    <span className="mb2-card__price">Rs {b.price}</span>
                  </div>

                  {/* Note */}
                  {b.note ? <p className="mb2-card__note">📝 {b.note}</p> : null}

                  {/* Customer media */}
                  {b.customerMedia && b.customerMedia.length > 0 && (
                    <div className="mb2-media-row">
                      <span className="mb2-media-label"><ImgIcon size={13}/> Your Photos/Videos:</span>
                      <div className="mb2-media-thumbs">
                        {b.customerMedia.map((m, mi) => (
                          <button key={mi} className="mb2-media-thumb" onClick={() => setLightbox(m)}>
                            {m.type==='video'
                              ? <><img src={m.thumb||m.url} className="mb2-media-thumb__img" alt=""/><div className="mb2-media-thumb__play"><Play size={14} fill="#fff" color="#fff"/></div></>
                              : <img src={m.url} className="mb2-media-thumb__img" alt=""/>}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Worker proof media */}
                  {b.workerMedia && b.workerMedia.length > 0 && (
                    <div className="mb2-media-row">
                      <span className="mb2-media-label" style={{ color:'#10b981' }}><ImgIcon size={13}/> Worker's Proof:</span>
                      <div className="mb2-media-thumbs">
                        {b.workerMedia.map((m, mi) => (
                          <button key={mi} className="mb2-media-thumb" onClick={() => setLightbox(m)}>
                            {m.type==='video'
                              ? <><video src={m.url} className="mb2-media-thumb__img"/><div className="mb2-media-thumb__play"><Play size={12} fill="#fff" color="#fff"/></div></>
                              : <img src={m.url} className="mb2-media-thumb__img" alt=""/>}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Existing review */}
                  {b.review && (
                    <div className="mb2-review">
                      <div className="mb2-review__header"><Stars rating={b.review.rating}/></div>
                      <p className="mb2-review__text">{b.review.text}</p>
                    </div>
                  )}

                  {/* ── Actions ── */}
                  <div className="mb2-card__actions">

                    {b.state==='open' && (
                      <div className="mb2-info">⏳ Waiting for worker to accept your booking</div>
                    )}

                    {b.state==='assigned' && (
                      <div className="mb2-info">✅ Worker accepted — job will start soon</div>
                    )}

                    {b.state==='in_progress' && (
                      <>
                        <div className="mb2-info">🔧 Worker is currently working on your job</div>
                        <button className="mb2-btn mb2-btn--dispute-customer" onClick={() => handleDispute(b)}>
                          <ShieldAlert size={14}/> Raise Dispute
                        </button>
                      </>
                    )}

                    {b.state==='awaiting_confirmation' && (
                      <>
                        <div className="mb2-proof-note">Worker has submitted proof of completion. Please review and confirm.</div>
                        <div className="mb2-btn-row">
                          <button className="mb2-btn mb2-btn--confirm" onClick={() => handleConfirm(b.id)}>
                            <CheckCheck size={14}/> Confirm Complete
                          </button>
                          <button className="mb2-btn mb2-btn--dispute" onClick={() => handleDispute(b)}>
                            <ShieldAlert size={14}/> Raise Dispute
                          </button>
                        </div>
                      </>
                    )}

                    {b.state==='completed' && !b.review && (
                      <div className="mb2-review-form">
                        <p className="mb2-review-form__label">Leave a review:</p>
                        <StarPicker
                          value={rv.rating || 0}
                          onChange={val => setReviewField(b.id, 'rating', val)}
                        />
                        <div className="mb2-review-form__row">
                          <input
                            type="text"
                            placeholder="Write your review..."
                            value={rv.text || ''}
                            onChange={e => setReviewField(b.id, 'text', e.target.value)}
                            onKeyDown={e => e.key==='Enter' && handleReview(b.id)}
                            className="mb2-review-form__input"
                          />
                          <button className="mb2-review-form__btn" onClick={() => handleReview(b.id)}>
                            <Send size={14}/>
                          </button>
                        </div>
                      </div>
                    )}

                    {b.state==='completed'   && b.review && <div className="mb2-done">✅ Job completed & reviewed!</div>}
                    {b.state==='cancelled'              && <div className="mb2-cancelled">❌ Booking cancelled</div>}
                    {b.state==='refunded'               && <div className="mb2-done">💸 Refunded to you</div>}
                    {b.state==='admin_review'           && <div className="mb2-dispute">⚠️ Escalated for manual review</div>}
                    {b.state==='worker_dispute'         && <div className="mb2-dispute">🛡️ Worker raised a dispute — Admin reviewing</div>}

                    {b.state==='dispute_frozen' && (
                      <div className="mb2-dispute-wrap">
                        <div className="mb2-dispute">🔒 Dispute raised — Admin reviewing</div>
                        <button
                          className="mb2-btn mb2-btn--support"
                          onClick={() => openTicketChat(b)}
                        >
                          <Headphones size={14}/> Chat
                        </button>
                      </div>
                    )}

                    {/* FIX 2: updated message */}
                    {b.state==='customer_dispute' && (
                      <div className="mb2-dispute-wrap">
                        <div className="mb2-dispute">🛡️ Your dispute has been submitted. Please explain your issue to the admin — Admin will review your dispute and get back to you with a response.</div>
                        <button
                          className="mb2-btn mb2-btn--support"
                          onClick={() => openTicketChat(b)}
                        >
                          <Headphones size={14}/> chat
                        </button>
                      </div>
                    )}

                  </div>

                </div>
              );
            })
          }
        </div>
      </div>
      <Lightbox item={lightbox} onClose={() => setLightbox(null)}/>
    </>
  );
};

export default MyBookings;